"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CoreButtonNext = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreButtonNextSt = require("./CoreButtonNext.st.css");
var _constants = require("./constants");
var _isStatelessComponent = require("./utils/isStatelessComponent");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const _addAffix = (Affix, styleClass, dataHook) => Affix && /*#__PURE__*/React.cloneElement(Affix, {
  className: (0, _classnames.default)(_CoreButtonNextSt.classes[styleClass], Affix.props.className),
  'data-hook': Affix.props['data-hook'] || Affix.props.dataHook || dataHook
});

/**
 * CoreButtonNext
 */
class CoreButtonNextComponent extends React.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "innerComponentRef", void 0);
  }
  focus() {
    if (this.innerComponentRef && this.innerComponentRef.focus) {
      this.innerComponentRef.focus();
    }
  }
  render() {
    const {
      as: Component,
      suffixIcon,
      prefixIcon,
      children,
      disabled,
      focusableOnFocus,
      focusableOnBlur,
      href,
      contentClassName,
      contentRef,
      ...rest
    } = this.props;
    const htmlTabIndex = disabled ? -1 : rest.tabIndex || 0;
    const htmlHref = disabled ? undefined : href;
    const reference = (0, _isStatelessComponent.isStatelessComponent)(Component) && typeof Component !== 'string' ? undefined : ref => this.innerComponentRef = ref;
    return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({}, rest, {
      onFocus: focusableOnFocus,
      onBlur: focusableOnBlur,
      disabled: href ? undefined : disabled,
      href: htmlHref,
      ref: reference,
      tabIndex: htmlTabIndex,
      "aria-disabled": disabled,
      className: (0, _CoreButtonNextSt.st)(_CoreButtonNextSt.classes.root, {
        disabled
      }, this.props.className),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 7
      }
    }), _addAffix(prefixIcon, 'prefix', _constants.dataHooks.prefixIcon), /*#__PURE__*/React.createElement("span", {
      className: (0, _CoreButtonNextSt.st)(_CoreButtonNextSt.classes.content, contentClassName),
      ref: contentRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 9
      }
    }, children), _addAffix(suffixIcon, 'suffix', _constants.dataHooks.suffixIcon));
  }
}
(0, _defineProperty2.default)(CoreButtonNextComponent, "defaultProps", {
  as: 'button',
  type: 'button'
});
(0, _defineProperty2.default)(CoreButtonNextComponent, "displayName", 'ButtonNext');
const CoreButtonNext = CoreButtonNextComponent;
exports.CoreButtonNext = CoreButtonNext;
//# sourceMappingURL=CoreButtonNext.js.map